import component from './analysis.component';
import filter from './filter/filter.service';
import item from './item/item.component';
import search from './search/search.component';
import sidebar from './sidebar/sidebar.component';

export default angular.module('mpdx.reports.analysis', [component, filter, item, search, sidebar]).name;
